import { createFileRoute, redirect } from "@tanstack/react-router";

// The old standalone /pricing page (PricingPanel) is retired — pricing now lives
// in Settings → Packages. Anything still pointing here (bookmarks, old links, a
// stale checkout cancel_url) redirects to the live surface instead of rendering
// the dead UI.
export const Route = createFileRoute("/pricing")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/packages" });
  },
});
